// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"_variables__pc_only____TkWS","sp_only":"_variables__sp_only___12UcC"};